export enum Language {
  EN = "en",
  DE = "de",
  FR = "fr",
  NL = "nl"
}

export const toLanguage = (value?: string): Language =>
  Object.values(Language).includes(value as Language)
    ? (value as Language)
    : Language.DE;
